package hk.com.vr360_demo2.webapp.ui

import mui.material.CssBaseline
import mui.material.styles.ThemeProvider
import react.Context
import react.FC
import react.PropsWithChildren
import react.createContext
import react.useState

data class ThemeController(
    val isDark: Boolean,
    val toggle: () -> Unit,
)

private val defaultThemeController = ThemeController(
    isDark = false,
    toggle = {},
)

private val ThemeContext: Context<ThemeController> = createContext(defaultThemeController)

val ThemeModule = FC<PropsWithChildren> { props ->
    val (isDark, setIsDark) = useState(false)
    val controller = ThemeController(
        isDark = isDark,
        toggle = { setIsDark(!isDark) },
    )

    ThemeContext.Provider {
        value = controller
        ThemeProvider {
            theme = if (isDark) darkTheme else lightTheme
            CssBaseline {}
            +props.children
        }
    }
}

fun useThemeController(): ThemeController {
    val react = js("require('react')")
    return react.useContext(ThemeContext) as ThemeController
}
